import { Component, OnInit } from '@angular/core';
import { ShoppingService } from '../../core/services/shopping.service';
import { CartItemsModel } from '../../core/models/ShoppingCart.model';
import { environment } from '../../../environments/environment';
import { Route, ActivatedRoute, Router } from '@angular/router';
import { HelperService } from '../../core/services/helper.service';
import { appVariables, appApiResources, overLimitCartDetails } from '../../core/constants/Common.constant';

@Component({
  selector: 'app-cart-items',
  templateUrl: './cart-items.component.html',
  styleUrls: ['./cart-items.component.css']
})
export class CartItemsComponent implements OnInit {
  CartItemsList: CartItemsModel[];
  ImageUrl: string;
  BackToPageUrl: string;
  loading = false;
  cartQuantityLimit = overLimitCartDetails;

  constructor(private shoppingService: ShoppingService,
    private helperService: HelperService, private router: Router, private route: ActivatedRoute) {
    this.ImageUrl = environment.imageUrl;
  }

  ngOnInit() {
    this.helperService.observeLoading.subscribe(loadingobj => {
      this.loading = loadingobj;
    });
    this.shoppingService.observeCartItems.subscribe(cartItemsList => {
      for (let i = 0; i < cartItemsList.length; i++) {
        if (cartItemsList[i].ImageUrl) {
          cartItemsList[i].ImageUrl = cartItemsList[i].ImageUrl;
          cartItemsList[i].strNetPrice = cartItemsList[i].strNetPrice.replace(',', '');
          // this.ImageUrl + && !this.CartItemsList[i].ImageUrl.includes(this.ImageUrl)
        }
      }
      this.CartItemsList = cartItemsList;
    });
    this.shoppingService.observeBackToPageUrl.subscribe(appurl => {
      this.BackToPageUrl = appurl;
    });
  }
  OnChange() {
    this.router.navigate([appApiResources.cartUrl2], { relativeTo: this.route });
  }
  OnContinueShopping() {
    this.helperService.backToSite(this.BackToPageUrl);
  }
  setDefaultPic(cartitems) {
    cartitems.ImageUrl = environment.defaultProductImage; // 'assets/images/my-image.png';
  }
  setParentPic(cartitems) {
    let isbn = '';
    this.shoppingService.GetParentProductImageFromAPI(cartitems.ProductID, isbn)
      .subscribe(
        (response) => {
          cartitems.ImageUrl = response.Data;
        },
        (error) => {
          // .status === 401
          if (error) {

          }
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/shoppingcart/cart-items/cart-items.component.ts